module.exports = __webpack_public_path__ + "img/3-3.1b8ab1f.png";